import { GlBadge, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
export default {
    name: 'ImportedBadge',
    tooltip: s__('BulkImport|This item was imported from another instance.'),
    components: {
        GlBadge
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        textOnly: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
